// Full-document render of the tempurpedic TempurLoveStoryPage: PageSkeleton
// (the React document shell) wrapping the hub header and the existing
// story-page body island. Both are gated on love_root -- the header matched
// the legacy partial's {% if love_root %}, and the body island's props
// require a non-null love_root (story pages only exist under a
// TempurLoveRootPage).
import React from "react";

import { templates } from "@reactivated";

import { TempurLoveStoryPage as TempurLoveStoryPageBody } from "../apps/tempur-love/TempurLoveStoryPage";
import { PageSkeleton } from "../components/PageSkeleton";
import { TempurLoveHeader } from "../components/TempurLoveHeader";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton).
type IProps = templates.TempurLoveStoryPageDocumentTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            {props.love_root && (
                <>
                    <TempurLoveHeader love_root={props.love_root} />
                    <TempurLoveStoryPageBody
                        {...props}
                        love_root={props.love_root}
                    />
                </>
            )}
        </PageSkeleton>
    );
};
